/**
 * 포인트 API
 *
 * @CODE:API-202 | SPEC: olulo-mx-admin/.claude/specs/SPEC-202-points-coupons-api.md
 */
import { apiClient } from './client';
import type {
  PointBalanceResponse,
  StorePointBalanceResponse,
  PointHistoryResponse,
  PointTransactionType,
  PointScopeType,
  StoreAvailablePointsResponse,
  EstimatePointsRequest,
  EstimatePointsResponse,
} from './types';

export interface GetPointHistoryParams {
  type?: PointTransactionType;
  scope_type?: PointScopeType;
  scope_id?: number;
  page?: number;
  per_page?: number;
}

export const pointsApi = {
  /**
   * 포인트 잔액 조회
   * GET /api/v1/points
   */
  getBalance: async (): Promise<PointBalanceResponse> => {
    const response = await apiClient.get<PointBalanceResponse>('/api/v1/points');
    return response;
  },

  /**
   * 매장별 포인트 잔액 조회
   * GET /api/v1/points?store_id={storeId}
   */
  getStoreBalance: async (storeId: number): Promise<StorePointBalanceResponse> => {
    const response = await apiClient.get<StorePointBalanceResponse>(
      '/api/v1/points',
      { params: { store_id: storeId } }
    );
    return response;
  },

  /**
   * 포인트 내역 조회
   * GET /api/v1/points/history
   */
  getHistory: async (params?: GetPointHistoryParams): Promise<PointHistoryResponse> => {
    const response = await apiClient.get<PointHistoryResponse>(
      '/api/v1/points/history',
      { params: params as Record<string, string | number | boolean | undefined> }
    );
    return response;
  },

  /**
   * 매장에서 사용 가능한 포인트 조회
   * GET /api/v1/stores/{storeId}/points/available
   *
   * @see olulo-mx-admin/routes/customer-api.php:133-135
   */
  getStoreAvailablePoints: async (
    storeId: number,
    orderAmount?: number,
  ): Promise<StoreAvailablePointsResponse> => {
    const response = await apiClient.get<StoreAvailablePointsResponse>(
      `/api/v1/stores/${storeId}/points/available`,
      {
        params: orderAmount !== undefined && orderAmount > 0
          ? { order_amount: orderAmount }
          : undefined,
      },
    );
    return response;
  },

  /**
   * 적립 예정 포인트 추정
   * POST /api/v1/stores/{storeId}/points/estimate
   */
  estimatePoints: async (storeId: number, params: EstimatePointsRequest): Promise<EstimatePointsResponse> => {
    const response = await apiClient.post<EstimatePointsResponse>(
      `/api/v1/stores/${storeId}/points/estimate`,
      params
    );
    return response;
  },
};
